import React  from 'react';
import ProfessionalCovenants from './ProfessionalCovenants';
import ProfessionalName from './ProfessionalName';
import ProfessionalSpecialities from './ProfessionalSpecialities';

import { Typography } from '@mui/material';

const InformationImagenologia = ({ professional }) => {

  return (
    <>
      <ProfessionalName nameProfessional={professional.ptdNombre} />
      <div style={{ marginBottom: '16px' }}>
        <ProfessionalSpecialities specialities={professional.especialidades} />
      </div>

      <Typography mb={2} style={{ fontWeight: "500", display: "inline-block", fontSize: 14, backgroundColor: "#fff9c4", color: "#f57f17", padding: "0.25rem 0.5rem", }}>
        Examen con indicaciones        
      </Typography>

      <ProfessionalCovenants covenants={professional.convenios} />      
    </>
  )
}

export default InformationImagenologia
